<template>
  <div class="page-shell page-shell--clue-manage">
    <section class="page-shell__content">
      <div class="page-shell__panel">
        <public-table
          v-loading="listLoading"
          :column="column"
          :tableData="clueManageList"
          :PageInfo="listQuery"
          :enableSearch="true"
          :searchItems="searchItems"
          @handlePaginationChange="handleLoadClueList"
          :is_table="true"
        >
          <template v-slot:createTime="{ row }">
            {{ row.createTime ? timetrans(row.createTime) : '-' }}
          </template>
          <template v-slot:content="{ row }">
            <a-tooltip placement="topLeft">
              <template #title>
                <span>{{ row.content }}</span>
              </template>
              {{ row.content }}
            </a-tooltip>
          </template>
        </public-table>
      </div>
    </section>
  </div>
</template>

<script>
import { fetchEnterpriseClue } from '@/api/enteriseApp';
import { timetrans } from '@/utils/validate';
export default {
  name: '',
  components: {},
  data() {
    return {
      // 表格的列
      column: [
        {
          prop: 'userName',
          label: '姓名'
        },
        {
          prop: 'mobile',
          label: '手机'
        },
        {
          prop: 'companyName',
          label: '公司名称'
        },
        {
          prop: 'appName',
          label: '应用名称'
        },
        {
          prop: 'content',
          label: '咨询事宜',
          scopeStatus: true
        },
        {
          prop: 'createTime',
          label: '创建时间',
          width: '300px',
          scopeStatus: true
        }
      ],
      //   搜索
      searchItems: [
        {
          label: '应用名称',
          name: 'query',
          span: 9,
          value: '',
          type: 'input'
        }
      ],
      // 线索管理
      clueManageList: [],
      //   分页
      listQuery: { page: 1, pageSize: 10, appName: '' },
      total: '',
      listLoading: true,
      timetrans
    };
  },
  props: {},
  computed: {
    eid() {
      return this.$store.state.user.userInfo.eid;
    }
  },
  watch: {},
  created() {
    this.handleLoadClueList();
  },
  methods: {
    async handleLoadClueList(parameter) {
      try {
        if (parameter) {
          this.listQuery.page = 1; // 如果是搜索 page为1
          this.listQuery = Object.assign(this.listQuery, parameter, {
            appName: parameter.query || ''
          });
        }
        const { businessList, total } = await fetchEnterpriseClue(
          Object.assign({}, this.listQuery, { eid: this.eid })
        );
        this.clueManageList = businessList || [];
        this.listQuery.total = total || 0;
        this.listLoading = false;
      } catch (error) {
        this.$message({
          type: 'error',
          message: '加载失败'
        });
        this.listLoading = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import 'src/styles/page-shell.scss';

::v-deep .el-table__row > td:nth-child(5) > div,
::v-deep .el-table__row > td:nth-child(5) > .cell {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/clueManage/index.vue